import React from 'react';

import type { ButtonBaseProps } from '@mui/material';
import { ButtonBase, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  button: {
    borderBottom: `1px solid ${theme.appColors.rule}`,
    color: theme.appColors.iconsType,
    padding: theme.spacing(2),
    width: '100%',
  },
  text: {
    flexGrow: 1,
    marginLeft: theme.spacing(2),
  },
}));

interface FieldActionProps extends ButtonBaseProps {
  leftIcon: React.ReactNode;
  text: string;
  rightIcon?: React.ReactNode;
}

export function FieldActionButton(props: FieldActionProps): JSX.Element {
  const { leftIcon, rightIcon, text, ...rest } = props;

  const { classes } = useStyles();

  return (
    <ButtonBase className={classes.button} {...rest}>
      {leftIcon}
      <Typography align="left" className={classes.text} variant="body1">
        {text}
      </Typography>
      {rightIcon}
    </ButtonBase>
  );
}
